import { defineMessages } from 'react-intl'

export const titleMessages = defineMessages({
  listing: {
    defaultMessage: 'Report an Item'
  },
  user: {
    defaultMessage: 'Report a User'
  }
})

export const subtitleMessages = defineMessages({
  listing: {
    defaultMessage: 'Why Are you Reporting this Listing?'
  },
  user: {
    defaultMessage: 'Why Are you Reporting this User?'
  }
})
